/**
 * Email Ad Validation Filters Component
 */
import { useState, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import SelectDropdown from '../../../components/SelectDropdown';
import Button from '../../../components/Button';

const ClearFilterButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.promotionStatus.closed,
  marginRight: '6px',
}));

const statusFilters = [
  { label: 'Queued', value: 'QUEUED' },
  { label: 'In Process', value: 'IN_PROGRESS' },
  { label: 'Completed', value: 'COMPLETED' },
  { label: 'Failed', value: 'FAILED' },
];

const emailTypeFilters = [
  { label: 'Promotion', value: 'PROMOTION' },
  { label: 'Reminder', value: 'REMINDER' },
];

const EmailAdValidationFilters = ({
  handleSelectedFilters = () => {},
  handleClearedFilterState = () => {},
  filters = {},
}) => {
  const [resetStatus, setResetStatus] = useState(false);
  const [resetEmailType, setResetEmailType] = useState(false);
  const [selectedFilters, setSelectedFilters] = useState(filters);

  // Sync with parent filters only when parent filters change externally
  useEffect(() => {
    setSelectedFilters(filters);
  }, [filters]);

  const onFilterValueChange = useCallback(
    (name, value) => {
      setSelectedFilters((prevFilters) => {
        const newFilters = { ...prevFilters };

        if (value) {
          newFilters[name] = value;
        } else {
          delete newFilters[name];
        }

        // Trigger parent callback with the updated filters
        handleSelectedFilters(newFilters);
        return newFilters;
      });
    },
    [handleSelectedFilters]
  );
  const onClearFilters = () => {
    setSelectedFilters({});
    setResetStatus(true);
    setResetEmailType(true);
    handleClearedFilterState();
  };

  const handleResetComplete = (filterType) => {
    switch (filterType) {
      case 'status':
        setResetStatus(false);
        break;
      case 'emailType':
        setResetEmailType(false);
        break;
      default:
        break;
    }
  };

  return (
    <Grid container spacing={2} alignItems="center" justifyContent="flex-end">
      {/* Status Filter */}
      <Grid item>
        <SelectDropdown
          label="Status"
          value={selectedFilters.status || ''}
          options={statusFilters}
          handleFilterChange={(value) => onFilterValueChange('status', value)}
          resetValues={resetStatus}
          handleResetValues={() => handleResetComplete('status')}
          style={{ minWidth: '120px' }}
        />
      </Grid>

      {/* Email Type Filter */}
      <Grid item>
        <SelectDropdown
          label="Email Type"
          value={selectedFilters.emailType || ''}
          options={emailTypeFilters}
          handleFilterChange={(value) => onFilterValueChange('emailType', value)}
          resetValues={resetEmailType}
          handleResetValues={() => handleResetComplete('emailType')}
          style={{ minWidth: '140px' }}
        />
      </Grid>

      {/* Clear Filters Button */}
      <Grid item>
        <ClearFilterButton
          variant="contained"
          onClick={onClearFilters}
          size="small"
          style={{
            textTransform: 'none',
            fontWeight: '600',
            height: '40px',
          }}
        >
          Clear Filters
        </ClearFilterButton>
      </Grid>
    </Grid>
  );
};

EmailAdValidationFilters.propTypes = {
  handleSelectedFilters: PropTypes.func,
  handleClearedFilterState: PropTypes.func,
  filters: PropTypes.object,
};

export default EmailAdValidationFilters;
